export const COMMONFONTSIZE = {
  HEADER_TEXT_FONT_SIZE: "32px",
  EXTRA_LARGE_FONT_SIZE: "20px",
  LARGE_MEDIUM_FONT_SIZE: "18px",
  LARGE_FONT_SIZE: "16px",
  MEDIUM_FONT_SIZE: "14px",
  SMALL_FONT_SIZE: "12px",
};

export const COMMONFONTWEIGHT = {
  LARGE_FONT_WEIGHT: "700",
  MEDIUM_LARGE_FONT_WEIGHT: "600",
  MEDIUM_FONT_WEIGHT: "500",
  SMALL_FONT_WEIGHT: "400",
};
